import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "mtree-select-wrapper" }
const _hoisted_2 = ["tabindex"]
const _hoisted_3 = {
  key: 0,
  class: "mtree-select__value"
}
const _hoisted_4 = {
  key: 1,
  class: "mtree-select__placeholder"
}
const _hoisted_5 = {
  class: "mtree-select__content",
  ref: "contentRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selector_search_header = _resolveComponent("selector-search-header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "triggerRef",
      class: _normalizeClass(["mtree-select", {
        'mtree-select--open': _ctx.isOpen,
        'mtree-select--disabled': _ctx.disable,
        'mtree-select--focused': _ctx.isFocused,
      }]),
      tabindex: _ctx.disable ? -1 : 0,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onTriggerKeydown && _ctx.onTriggerKeydown(...args))),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isFocused = true)),
      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onTriggerBlur && _ctx.onTriggerBlur(...args)))
    }, [
      (_ctx.displayText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.displayText), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.placeholder), 1)),
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["mtree-select__chevron", { 'mtree-select__chevron--open': _ctx.isOpen }]),
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, _cache[6] || (_cache[6] = [
        _createElementVNode("path", {
          d: "M4 6L8 10L12 6",
          stroke: "#999",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)
      ]), 2))
    ], 42, _hoisted_2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "mtree-select-dropdown" }, {
        default: _withCtx(() => [
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref: "floatingRef",
                class: _normalizeClass(["mtree-select__dropdown", { 'mtree-select__dropdown--no-search': !_ctx.showSearchHeader }]),
                style: _normalizeStyle(_ctx.floatingStyles),
                onFocusin: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
              }, [
                (_ctx.showSearchHeader)
                  ? (_openBlock(), _createBlock(_component_selector_search_header, {
                      key: 0,
                      ref: "searchHeader",
                      modelValue: _ctx.searchText,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchText) = $event)),
                      "show-close-button": true,
                      "use-own-clear-button": true,
                      "show-free-input": _ctx.showFreeInput,
                      "free-input-tooltip": _ctx.freeInputTooltip,
                      onKeyUp: _ctx.emitKeyUp,
                      onKeyDown: _ctx.emitKeyDown,
                      onKeyEnter: _ctx.emitKeyEnter,
                      onInputPressed: _ctx.onFreeInputPressed,
                      onClose: _ctx.close
                    }, null, 8, ["modelValue", "show-free-input", "free-input-tooltip", "onKeyUp", "onKeyDown", "onKeyEnter", "onInputPressed", "onClose"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ], 512)
              ], 38))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]))
  ]))
}